export const WF = {
  CREATE: 1, USER_CANCEL: 2, RETURN: 3, ADMIN_CANCEL: 4,
  ASSIGN: 5, DOING: 6, COMPLETE: 7, INCOMPLETE: 8,
  REASSIGN: 9, CLOSE_OK: 10, CLOSE_COND: 11, USER_RESPONDED: 19,
};